import React from 'react';
import { Trans } from '@lingui/react';

import Text, { Props as TextProps } from '@rover/kibble/core/Text/Text';

import { validateParagraphText } from '../TextWithSingleInlineLink/TextWithSingleInlineLink.common';

import { TextWithSingleInlineColorProps } from './TextWithSingleInlineColor.common';

/** Props for web TextWithSingleInlineColor component */
export type Props = TextWithSingleInlineColorProps & Omit<TextProps, 'children' | 'as'>;

/**
 * TextWithSingleInlineColor is a helper component that ensures good a11y behavior and good structure for ease
 *   of translation for text with specifically colored segments.
 *
 */
const TextWithSingleInlineColor: React.FC<Props> = ({
  paragraphText,
  size,
  textColor,
  highlightColor,
  fontWeight,
  ...textProps
}) => {
  validateParagraphText(paragraphText);
  return (
    <Text
      data-testid="text-with-single-inline-color"
      size={size}
      fontWeight={fontWeight}
      textColor={textColor}
      {...textProps}
    >
      <Trans
        id={paragraphText}
        message={paragraphText}
        components={[
          <Text
            webProps={{ as: 'strong' }}
            fontWeight="semibold"
            textColor={highlightColor}
            size={size}
            key={paragraphText}
          >
            ''
          </Text>,
        ]}
      />
    </Text>
  );
};

export default TextWithSingleInlineColor;
